import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private httpClient: HttpClient) { }

  public generateParams(list: any) {
    let param = new HttpParams();
    for (const k in list) {
      param = param.append(k, list[k]);
    };
    return param;
  }

  public getData(qParams: any) {
    const qParamsString = this.generateParams(qParams);
    return this.httpClient.get(environment.apiUrl, { params: qParamsString })
  }

  public postData(qParams: any, option: any) {
    const qParamsString = this.generateParams(qParams);
    return this.httpClient.post<any>(environment.apiUrl, option, { params: qParamsString });
  }

  public postFormData(qParams: any, formData: FormData) {
    const qParamsString = this.generateParams(qParams);
    return this.httpClient.post<any>(environment.apiUrl, formData, { params: qParamsString });
  }

}